export default __webpack_public_path__ + "static/media/mobile_beehive_status_2.289c51bb.png";